import React from "react";
import { useNavigate } from "react-router-dom";
import { Users, CalendarDays, Wallet,PhoneCall } from "lucide-react"; // modern icons from lucide-react

function Staffdashboard() {
  const navigate = useNavigate();

  const cards = [
    {
      title: "All Staff",
      icon: <Users size={40} className="text-indigo-600" />,
      path: "/dashboard/all-staff",
    },
    {
      title: "Leave Management",
      icon: <CalendarDays size={40} className="text-green-600" />,
      path: "/dashboard/leave-management",
    },
    {
      title: "Salary Management",
      icon: <Wallet size={40} className="text-pink-600" />,
      path: "/dashboard/salary-management",
    },
    {
      title: "Contact",
      icon: <PhoneCall size={40} className="text-red-600" />,
      path: "/dashboard/contact",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 px-6 py-10">
      <h1 className="text-3xl font-semibold text-gray-800 mb-10 text-center">
        Staff Dashboard
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {cards.map((card, index) => (
          <div
            key={index}
            onClick={() => navigate(card.path)}
            className={`cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 p-8 flex flex-col items-center text-center border border-gray-100 hover:-translate-y-1`}
          >
            <div
              className={`w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-r  mb-4`}
            >
              {card.icon}
            </div>
            <h2 className="text-xl font-semibold text-gray-700">
              {card.title}
            </h2>
          </div>
          
        ))}
      </div>
    </div>
  );
}

export default Staffdashboard;
